exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "[data-no-op]{z-index:1000;position:absolute;height:100%;width:100%;text-align:center}[data-no-op] p[data-no-op-msg]{position:absolute;text-align:center;font-size:25px;left:0;right:0;color:#fff;margin:10px;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}[data-no-op] canvas[data-no-op-canvas]{background-color:#777;height:100%;width:100%}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./src/playbacks/no_op/public/style.scss
 ** module id = 130
 ** module chunks = 0
 **/